/* 해외 방문자 달러 표시 (사장님 지시 2026-08-01)
 * - 시간대가 한국이 아니면 ₩ 가격을 달러로 환산해 "표시만" 바꾼다. 결제는 원화 그대로.
 * - 우하단 작은 토글(₩/$)로 언제든 전환. 선택은 기기에 저장.
 * - 환율(AF_USD_RATE)은 서버 스크립트가 매일 갱신한다. ?usd=1 로 강제 테스트 가능.
 */
(function () {
  var AF_USD_RATE = 1356.73; /* auto-updated */
  var KRW = /₩\s?([0-9][0-9,]*)/g;

  function foreignTz() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      return tz !== 'Asia/Seoul' && tz !== 'Asia/Pyongyang';
    } catch (e) { return false; }
  }

  function wantUsd() {
    var q = new URLSearchParams(location.search);
    if (q.get('usd') === '1') return true;
    if (q.get('usd') === '0') return false;
    // 마켓 국가가 곧 표시 통화 — 해외 마켓이면 $, 한국이면 ₩ (화면가=결제가)
    if (window.AF_COUNTRY && window.AF_COUNTRY !== 'KR') return true;
    if (window.AF_COUNTRY === 'KR') return false;
    return foreignTz();
  }

  /* 해외 방문자 자동 전환 (사장님 지시 2026-08-01, SHIP TO 제거와 세트):
     시간대가 한국이 아닌데 마켓이 아직 KR이면, 숨은 localization 폼으로 US 마켓에
     넘긴다 — 그래야 화면 가격(할증가)과 결제 금액이 일치한다. 1회만 시도. */
  function autoMarket() {
    if (window.AF_COUNTRY !== 'KR' || !foreignTz()) return false;
    if (sessionStorage.getItem('af.autoMarket')) return false;
    if (localStorage.getItem('af.manualMarket')) return false;
    var f = document.querySelector('.af-footer__loc-f');
    var sel = f && f.querySelector('select[name="country_code"]');
    if (!f || !sel) return false;
    sessionStorage.setItem('af.autoMarket', '1');
    sel.value = 'US';
    f.submit();
    return true;
  }

  function toUsd(won) {
    var n = Number(String(won).replace(/,/g, ''));
    if (!n || !AF_USD_RATE) return null;
    // 소수점 없이 정수 달러 (사장님 지시 2026-08-01)
    return '$' + String(Math.round(n / AF_USD_RATE)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function convertNode(node) {
    if (node.nodeType !== 3) return;
    var t = node.nodeValue;
    if (!t || t.indexOf('₩') === -1) return;
    var out = t.replace(KRW, function (m, num) {
      var usd = toUsd(num);
      return usd ? usd : m;
    });
    if (out !== t) {
      if (!node.parentElement) return;
      if (!node._afOrig) node._afOrig = t;
      node.nodeValue = out;
    }
  }

  function walk(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) convertNode(n);
  }

  function restore() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) if (n._afOrig) { n.nodeValue = n._afOrig; delete n._afOrig; }
  }

  var on = false, mo = null;

  function enable() {
    if (on) return; on = true;
    walk(document.body);
    mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (nd) {
          if (nd.nodeType === 1) walk(nd);
          else convertNode(nd);
        });
        if (m.type === 'characterData') convertNode(m.target);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    note(true);
  }

  function disable() {
    if (!on) return; on = false;
    if (mo) { mo.disconnect(); mo = null; }
    restore();
    note(false);
  }

  function note(usd) {
    var el = document.getElementById('af-usd-note');
    if (el) el.textContent = usd ? 'Prices shown in USD (approx.) · charged in KRW' : '';
  }

  function switchMarket(cc) {
    var f = document.querySelector('.af-footer__loc-f');
    var sel = f && f.querySelector('select[name="country_code"]');
    if (!f || !sel) return false;
    localStorage.setItem('af.manualMarket', '1');
    sel.value = cc;
    f.submit();
    return true;
  }

  /* 좌하단 스위치 — 표시가 아니라 **마켓**을 바꾼다 (사장님 지시 2026-08-01).
     한국 거주자도 해외 주문(할증가·달러 표시)으로 전환할 수 있다.
     최종 가격은 어차피 결제 화면의 배송국가가 결정하므로 잘못 눌러도 손해 없음. */
  function pill() {
    var kr = window.AF_COUNTRY === 'KR';
    var b = document.createElement('button');
    b.id = 'af-usd-pill';
    b.type = 'button';
    b.style.cssText = 'position:fixed;left:14px;bottom:14px;z-index:60;padding:7px 12px;border:1px solid #ccc;border-radius:999px;background:#fff;font-size:12px;cursor:pointer;letter-spacing:.02em';
    b.textContent = kr ? '$ International' : '₩ Korea';
    b.title = kr ? 'Switch to international pricing (USD)' : '한국 가격으로 보기';
    b.addEventListener('click', function () {
      if (!switchMarket(kr ? 'US' : 'KR')) { if (on) disable(); else enable(); }
    });
    var n = document.createElement('div');
    n.id = 'af-usd-note';
    n.style.cssText = 'position:fixed;left:14px;bottom:46px;z-index:60;font-size:10px;color:#888;max-width:220px';
    document.body.appendChild(n);
    document.body.appendChild(b);
  }

  function init() {
    if (autoMarket()) return;   // 페이지가 곧 새로고침되므로 나머지는 다음 로드에서
    pill();
    if (wantUsd()) enable();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
